import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  Outlet,
} from 'react-router-dom';
import './App.css';
import Main from './page/main/Main';
import Search from './page/search/Search';
import AuctionDetail from './page/detail/AuctionDetail';
import PAuctionDetail from './page/detail/PAuctionDetail';
import { ReportProvider } from './context/DetailContext';
import { AuthProvider } from './context/AuthContext';
import Login from './page/Login/Login';
import SignUp from './page/SignUP/signUp';
import MyPage from './page/mypage/Mypage';
import DeleteAccountPage from './page/deleteAccount/DeleteAccountPage';
import { UserProvider } from './context/UserContext';
import ChangePassword from './page/mypage/ChangePassword';
import ChangeContactNumber from './page/mypage/ChangeContact';
import BondSearch from './page/bondSearch/BondSearch';
import NplSearch from './page/nplSearch/NplSearch';
import AuctionSchedule from './page/auctionSchedule/AuctionSchedule';
import NewAuction from './page/newAuction/NewAuction';
import MyAlgorithm from './page/aiAnalyze/MyAlgorithm';
import { PatternProvider } from './context/PatternContext';
import LoginEmail from './page/Login/LoginEmail';
import SignUpComplete from './page/SignUP/SignUpComplete';
import { HelmetProvider } from 'react-helmet-async';
import SignUpSNS from './page/SignUP/SignUpSNS';
import Find from './page/find/Find';
import PaymentPlanRedirect from './page/components/pay/PaymentPlanRedirect';
import PaymentPlan from './page/pay/paymentPlan';
import ExclusivePaymentPlan from './page/pay/exclusivePaymentPlan';
import PaymentMethod from './page/pay/paymentMethod';
import PaymentComplete from './page/pay/paymentComplete';
import PaymentHistory from './page/mypage/payment/paymentHistory';
import Board from './page/customer/board/Board';
import FloatingInquiry from './page/customer/inquiry/FloatingInquiry';
import { ModalProvider } from './context/ModalContext';
import AiRecommendItem from './page/aiAnalyze/aiRecommend/AiRecommendation';
import MyPatternList from './page/aiAnalyze/MyPatternList';
import PatternResult from './page/aiAnalyze/PatternResult';
import Promotion from './page/promotion';
import Limit from './page/components/limit/Limit';
import Quent, { QuantOutlet1, QuantOutlet2 } from './page/quant/Quant';
import VIPReport from './page/quant/VIPReport/VIPReport';
import Service from './page/terms/Service';
import Privacy from './page/terms/Privacy';
import Location from './page/terms/Location';
import CompanyInfo from './page/companyInfo/CompanyInfo';
import { useEffect } from 'react';
import EarlyBird from './page/promotion/EarlyBird';
import FreeTrial from './page/promotion/FreeTrial';
import Guide from './page/Guide/Guide';
import { MapFilterProvider } from './context/MapFilterContext';
import { MapProvider } from './context/MapContext';
import MapSearch from './page/newMap/MapSearch';
import UserAlert from './page/components/userAlert/UserAlert';
import RouteGuard from './page/components/RouteGuard';
import ScheduledAuction from './page/scheduled/ScheduledAuction';
import ScheduledDetail from './page/scheduled/ScheduledDetail';
import FullScreenMap from './page/detail/components/ItemState/FullScreenMap';
import ItemDetailPage from './page/detail/courtInformation/ItemDetailPage';
import IncidentDetails from './page/detail/courtInformation/IncidentDetails';
import DateDetails from './page/detail/courtInformation/DateDetails';
import DocumentDeliveryDetails from './page/detail/courtInformation/DocumentDeliveryDetails';
import StatusServey from './page/detail/courtInformation/StatusSurvey';
import Studyroom from './page/Studyroom/Studyroom';
import MySearchOption from './page/search/mySearchOption/MySearchOption';
import AgentPaymentPlan from './page/pay/AgentPaymentPlan';
import SaveImages from './page/detail/components/summary/SaveImages';
import SummerFesta from './page/promotion/SummerFesta';
import ScrollToTop from './page/components/ScrollToTop';
import AILanding from './page/AIAuctionSearch/AILanding';
import FloatingButton from './page/components/FloatingButton';
import News from './page/news/News';
import NewsDetail from './page/news/NewsDetail';
import BoardDetail from './page/customer/board/BoardDetail';
import FreeTrial3 from './page/promotion/FreeTrial3';
import QuantGuide from './page/guideLanding/QuantGuide';
import { isAfterTime } from './utils/eventTime';
import VersionChecker from './func/versionChecker';
import DiscountAttack from './page/promotion/DiscountAttack';
import BottomNav from './page/components/bottomNav/BottomNav';
import Menu from './page/components/menu/Menu';
import QuickSearch from './page/quickSearch/QuickSearch';
import Seminar from './page/Seminar/Seminar';
import SignUpForm from './page/SignUP/SignUpForm';
import AlgorithmGuide from './page/guideLanding/Algorithm/AlgorithmGuide';
import Hangawi from './page/promotion/Hangawi';
import Game from './page/game/GameMain';
import GameDetail from './page/game/OpenGraph';
import GameResult from './page/game/GameResult';
import Gamelank from './page/game/GameItem';
import GameEvent from './page/game/GameItemEvent';
import GameSharePage from './page/game/GameSharePage';
import MapSearchGuide from './page/guideLanding/MapSearch/MapSearchGuide';
import Nplatform from './page/Seminar/Nplatform';
import PeriodStats from './page/Stats/PeriodStatsPage';
import PremiumStats from './page/Stats/PremiumStats';
import NPLStats from './page/Stats/NPLStats';
import Lucky from './page/promotion/Lucky';

function MainLayout({ children }: { children?: React.ReactNode }) {
  const location = useLocation();

  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
    fbq('track', 'PageView');
    `;

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
    
      gtag('config', 'G-CDJJ0W5YLJ');
    `;
    const script3 = document.createElement('script');
    script3.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-W6HDC7LG');
    `;
    const script4 = document.createElement('noscript');
    // const iframe4 = document.createElement('iframe');
    // iframe4.src = 'https://www.googletagmanager.com/ns.html?id=GTM-W6HDC7LG';
    // iframe4.height = '0';
    // iframe4.width = '0';
    // iframe4.style.display = 'none';
    // iframe4.style.visibility = 'hidden';
    // script4.appendChild(iframe4);
    script4.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-W6HDC7LG"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;

    document.head.appendChild(script);
    document.head.prepend(script2);
    document.head.prepend(script3);
    document.body.prepend(script4);
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(script2);
      document.head.removeChild(script3);
      document.body.removeChild(script4);
    };
  }, [location]);

  return (
    <>
      <RouteGuard />
      <UserAlert />
      <Outlet />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <UserProvider>
        <AuthProvider>
          <MapProvider>
            <MapFilterProvider>
              <ReportProvider>
                <PatternProvider>
                  <ModalProvider>
                    <VersionChecker />
                    <Limit />
                    <Router>
                      <ScrollToTop />
                      {/* <FloatingButton /> */}
                      <FloatingInquiry />
                      <BottomNav />
                      <Routes>
                        <Route element={<MainLayout />}>
                          <Route
                            path="*"
                            element={<Navigate to="/" replace />}
                          />
                          <Route path="/login" element={<Login />} />
                          {/* <Route path="/login/email" element={<LoginEmail />} /> */}
                          <Route path="/signUp" element={<SignUp />} />
                          <Route path="/signupForm" element={<SignUpForm />} />
                          <Route
                            path="/signUpComplete"
                            element={<SignUpComplete />}
                          />
                          <Route
                            path="/signupForm/sns"
                            element={<SignUpSNS />}
                          />
                          <Route path="/find" element={<Find />} />
                          <Route path="/" element={<Main />} />
                          <Route path="/menu" element={<Menu />} />
                          <Route path="/search" element={<Search />} />
                          <Route
                            path="/quick-search"
                            element={<QuickSearch />}
                          />
                          <Route
                            path="/search/mySearchOption"
                            element={<MySearchOption />}
                          />
                          <Route path="/search/bond" element={<BondSearch />} />
                          <Route path="/search/npl" element={<NplSearch />} />
                          <Route
                            path="/auctionSchedule"
                            element={<AuctionSchedule />}
                          />
                          <Route
                            path="/scheduledAuction"
                            element={<ScheduledAuction />}
                          />
                          <Route path="/NewAuction" element={<NewAuction />} />
                          <Route
                            path="/AiRecommendation"
                            element={<AiRecommendItem />}
                          />
                          <Route
                            path="/patternResult/:number"
                            element={<PatternResult />}
                          />
                          <Route
                            path="/myAlgorithmList"
                            element={<MyPatternList />}
                          />
                          <Route
                            path="/myAlgorithm"
                            element={<MyAlgorithm />}
                          />
                          <Route
                            path="/algorithm-guide"
                            element={<AlgorithmGuide />}
                          />

                          <Route
                            path="/auction/detail/:number"
                            element={<AuctionDetail />}
                          />
                          <Route
                            path="/pauction/detail/:number"
                            element={<PAuctionDetail />}
                          />
                          <Route
                            path="/itemDetail"
                            element={<ItemDetailPage />}
                          />
                          <Route
                            path="/incidentDetail"
                            element={<IncidentDetails />}
                          />
                          <Route path="/dateDetail" element={<DateDetails />} />
                          <Route
                            path="/documentDetail"
                            element={<DocumentDeliveryDetails />}
                          />
                          <Route
                            path="/statusServey"
                            element={<StatusServey />}
                          />
                          <Route
                            path="/scheduled/detail/:number"
                            element={<ScheduledDetail />}
                          />
                          <Route path="/mypage" element={<MyPage />} />
                          <Route
                            path="/deleteAccount"
                            element={<DeleteAccountPage />}
                          />
                          <Route
                            path="/mypage/payment"
                            element={<PaymentHistory />}
                          />
                          <Route
                            path="/changePassword"
                            element={<ChangePassword />}
                          />
                          <Route
                            path="/changeContact"
                            element={<ChangeContactNumber />}
                          />
                          <Route
                            path="/login"
                            element={<ChangeContactNumber />}
                          />
                          <Route
                            path="/payment/plan"
                            element={<PaymentPlanRedirect />}
                          />
                          <Route
                            path="/payment/바른NPL_특전_페이지"
                            element={<ExclusivePaymentPlan />}
                          />
                          <Route
                            path="/payment/공인중개사_특전_페이지"
                            element={<AgentPaymentPlan />}
                          />
                          <Route
                            path="/payment/method"
                            element={<PaymentMethod />}
                          />
                          <Route
                            path="/payment/complete"
                            element={<PaymentComplete />}
                          />
                          <Route
                            path="/login"
                            element={<ChangeContactNumber />}
                          />
                          <Route path="/board" element={<Board />} />
                          <Route
                            path="/board/detail/:articleidx"
                            element={<BoardDetail />}
                          />
                          <Route
                            path="/promotion/땅집고옥션-오픈기념-이벤트"
                            element={<Navigate to="/" replace />} //<Promotion />
                          />
                          <Route
                            path="/promotion/땅집고옥션-얼리버드-이벤트"
                            element={<Navigate to="/" replace />} //<EarlyBird />
                          />
                          <Route
                            path="/promotion/5일-무료체험-이벤트"
                            element={
                              <Navigate
                                to="/promotion/3일-무료체험-이벤트"
                                replace
                              />
                            }
                            // {<FreeTrial />}
                          />
                          <Route
                            path="/promotion/3일-무료체험-이벤트"
                            element={<FreeTrial3 />}
                          />
                          <Route
                            path="/promotion/땅집고옥션-썸머페스타-이벤트"
                            element={<Navigate to="/" replace />}
                          />
                          <Route
                            path="/promotion/땅집고옥션-할인어택-이벤트"
                            element={<Navigate to="/" replace />}
                            // element={<DiscountAttack />}
                          />
                          <Route
                            path="/promotion/10월_달달혜택_이벤트"
                            element={<Navigate to="/" replace />}
                          />
                          <Route
                            path="/promotion/땅집고옥션-럭키-이벤트"
                            element={<Lucky />}
                          />
                          <Route path="/quant" element={<Quent />}>
                            <Route path="" element={<QuantOutlet1 />} />
                            <Route path="theme" element={<QuantOutlet2 />} />
                          </Route>

                          <Route
                            path="/quant/vipreport/:quant_idx/:index"
                            element={<VIPReport />}
                          />
                          <Route path="/quant-guide" element={<QuantGuide />} />
                          <Route path="/terms/service" element={<Service />} />
                          <Route path="/terms/privacy" element={<Privacy />} />
                          <Route
                            path="/terms/location"
                            element={<Location />}
                          />
                          <Route
                            path="/companyinfo"
                            element={<CompanyInfo />}
                          />
                          <Route
                            path="/fullscreenMap"
                            element={<FullScreenMap />}
                          />
                          <Route path="/guide" element={<Guide />} />
                          <Route path="/studyroom" element={<Studyroom />} />
                          <Route path="/map" element={<MapSearch />} />
                          <Route path="/save-images" element={<SaveImages />} />
                          <Route path="/chat-start" element={<AILanding />} />
                          <Route path="/news" element={<News />} />
                          <Route
                            path="/news/detail/:number"
                            element={<NewsDetail />}
                          />
                          <Route path="/seminar2509" element={<Seminar />} />
                        </Route>
                        <Route
                          path="/quant/vipreport/:quant_idx/:index"
                          element={<VIPReport />}
                        ></Route>
                        <Route path="/terms/service" element={<Service />} />
                        <Route path="/terms/privacy" element={<Privacy />} />
                        <Route path="/terms/location" element={<Location />} />
                        <Route path="/companyinfo" element={<CompanyInfo />} />
                        <Route
                          path="/fullscreenMap"
                          element={<FullScreenMap />}
                        />
                        <Route path="/guide" element={<Guide />} />
                        <Route path="/studyroom" element={<Studyroom />} />
                        <Route path="/map" element={<MapSearch />} />
                        <Route path="/save-images" element={<SaveImages />} />
                        <Route path="/chat-start" element={<AILanding />} />
                        <Route path="/news" element={<News />} />
                        <Route
                          path="/news/detail/:number"
                          element={<NewsDetail />}
                        />
                        <Route path="/game" element={<Game />} />
                        <Route path="/game/detail" element={<GameDetail />} />
                        <Route
                          path="/game/result/:gameId/:playId/:playerId"
                          element={<GameResult />}
                        />
                        <Route path="/game/lank" element={<Gamelank />} />
                        <Route
                          path="/game/event/:gameId"
                          element={<GameEvent />}
                        />
                        <Route
                          path="/game/share/:gameId"
                          element={<GameSharePage />}
                        />
                        <Route path="/map-guide" element={<MapSearchGuide />} />
                        <Route
                          path="/엔플랫폼_설명회"
                          element={<Nplatform />}
                        />
                        <Route path="/period-stats" element={<PeriodStats />} />
                        <Route
                          path="/premium-stats"
                          element={<PremiumStats />}
                        />
                        <Route path="/npl-stats" element={<NPLStats />} />
                      </Routes>
                    </Router>
                  </ModalProvider>
                </PatternProvider>
              </ReportProvider>
            </MapFilterProvider>
          </MapProvider>
        </AuthProvider>
      </UserProvider>
    </HelmetProvider>
  );
}

export default App;
